import { render, staticRenderFns } from "./ProgressIndicator.vue?vue&type=template&id=8d08797c&scoped=true"
import script from "./ProgressIndicator.vue?vue&type=script&lang=ts"
export * from "./ProgressIndicator.vue?vue&type=script&lang=ts"
import style0 from "./ProgressIndicator.vue?vue&type=style&index=0&id=8d08797c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d08797c",
  null
  
)

export default component.exports
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCircularProgress,QIcon});
